// require('credentials-context/contexts/credentials/v1');
'use strict'; // load locally embedded contexts

var _regeneratorRuntime = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/asyncToGenerator");

var contexts = require('./contexts');

module.exports =
/*#__PURE__*/
function () {
  var _documentLoader = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(url) {
    var context;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log(url);
            context = contexts[url];

            if (!(context !== undefined)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", {
              contextUrl: null,
              documentUrl: url,
              document: context
            });

          case 4:
            throw new Error("".concat(url, " is not an authorized context url."));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function documentLoader(_x) {
    return _documentLoader.apply(this, arguments);
  }

  return documentLoader;
}();